import { render, staticRenderFns } from "./QuotationSettingsForm.vue?vue&type=template&id=01c6ad9e&scoped=true"
import script from "./QuotationSettingsForm.vue?vue&type=script&lang=js"
export * from "./QuotationSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationSettingsForm.vue?vue&type=style&index=0&id=01c6ad9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6ad9e",
  null
  
)

export default component.exports